export default {
  form: {
    bank_account_number: {
      label: 'Kontonummer',
      placeholder: 'DE01101234567891234567',
    },
    bank_routing_number: {
      label: 'Registreringsnummer',
      placeholder: '110000000',
    },
    bank_country: {
      label: 'Land',
      placeholder: 'Tyskland',
    },
    bank_statement_descriptor: {
      label: 'Betalingsbeskrivelse',
      placeholder: 'Restaurantnavn',
      tooltip: 'Dette navn vises på kundernes kontoudtog',
    },
  },
  buttons: {
    next: 'Næste',
    back: 'Tilbage',
    use_test_data: 'Brug testdata',
  },
  test_data_hint: 'Testbankkonto accepteret af {{gateways}}',
  read_only_warning: 'Bankoplysninger kan kun ændres af vores team. Kontakt support, hvis de skal opdateres.',
};
